export const getArtistRoute = () => '/artist';